/**
 * When the holders of an objective that is not complete yet are reminded of it, counted back from
 * its end date. Listed from the earliest to the latest, the order the form offers them in.
 */
export const ObjectiveReminder = {
    TWO_MONTHS_BEFORE_END: 'TwoMonthsBeforeEnd',
    ONE_MONTH_BEFORE_END: 'OneMonthBeforeEnd',
    TWO_WEEKS_BEFORE_END: 'TwoWeeksBeforeEnd',
} as const;

export type ObjectiveReminderValue = (typeof ObjectiveReminder)[keyof typeof ObjectiveReminder];
